import styled from 'styled-components';
import type { AvatarSizes } from '@frameio/vapor';
import { ProjectAvatar, Text, theme } from '@frameio/vapor';

export type ProjectHeaderContentProps = {
  avatarSize?: AvatarSizes;
  avatarUrl: string;
  details: string;
  emphasis?: 'prominent' | 'compact';
  isPrivate?: boolean;
  projectId: string;
  projectName: string;
  truncateName?: boolean;
};

export function ProjectHeaderContent({
  avatarSize = DEFAULT_AVATAR_SIZE,
  avatarUrl,
  details,
  emphasis = 'compact',
  isPrivate = false,
  projectId,
  projectName,
  truncateName = true,
}: ProjectHeaderContentProps) {
  const isProminent = emphasis === 'prominent';

  return (
    <>
      <ProjectAvatarContainer data-chromatic="ignore">
        <ProjectAvatar
          id={projectId}
          isPrivate={isPrivate}
          size={avatarSize}
          src={avatarUrl}
          title={projectName}
        />
      </ProjectAvatarContainer>

      <NamesContainer $isProminent={isProminent} data-chromatic="ignore">
        <Text
          color={isProminent ? 'primary' : 'body'}
          enableTooltip={true}
          fontWeight="medium"
          truncate={truncateName}
          variant={isProminent ? 'primary' : 'linkSmall'}
        >
          {projectName}
        </Text>
        <Text
          color="tertiary"
          fontWeight="regular"
          truncate={true}
          variant={isProminent ? 'caption' : 'secondary'}
        >
          {details}
        </Text>
      </NamesContainer>
    </>
  );
}

const DEFAULT_AVATAR_SIZE = 24;

const ProjectAvatarContainer = styled.div`
  display: inline-flex;
  padding: ${theme.spaces[2]};
`;

const NamesContainer = styled.div<{ $isProminent: boolean }>`
  margin-left: ${(p) => (p.$isProminent ? theme.spaces[8] : theme.spaces[12])};
  overflow: hidden;
  width: 100%;

  ${(p) =>
    p.$isProminent &&
    `
    padding: ${theme.spaces[2]} ${theme.spaces[16]} ${theme.spaces[2]} ${theme.spaces[2]};
  `}
`;
